/**
 * System-wide Action types
 */
export const ActionTypes = {
  // Notifications
  SYS_ADD_NOTIFICATION: "ADD_NOTIFICATION",
  SYS_ADD_ERROR_NOTIFICATION: "ADD_NOTIFICATION",

  // Error Handler
  SYS_HANDLE_ERROR: "HANDLE_ERROR",
  SYS_HANDLE_ERROR_SHOW_FORM: "SYS_HANDLE_ERROR_SHOW_FORM",
  SYS_HANDLE_ERROR_HIDE_FORM: "SYS_HANDLE_ERROR_HIDE_FORM",
};
